import { FormBuilderDisplayRenderer } from "../../../../FormBuilder/components/FormBuilderDisplayRenderer/index.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Events/shared/EventPresentation/components/EventInfoFormBuilder.tsx
function EventInfoFormBuilder({ event }) {
	if (!event.infoFormInput?.formId) return null;
	return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(FormBuilderDisplayRenderer, {
		formId: event.infoFormInput?.formId,
		valuesByFieldId: event.infoFormInput.fields
	}, event.id) });
}
//#endregion
export { EventInfoFormBuilder };

//# sourceMappingURL=EventInfoFormBuilder.js.map